import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { I18nextProvider } from 'react-i18next'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { AuthProvider } from './auth/AuthProvider'
import { AppBrandRoot } from './brand/app-brand-root'
import { i18n } from './i18n'
import { ToastProvider } from './notifications/ToastProvider'
import { RealtimeProvider } from './realtime/RealtimeProvider'
import { routes } from './routes'

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 5 * 60 * 1000, // 5 minutes
			retry: 1,
		},
	},
})

const router = createBrowserRouter(routes)

function App() {
	return (
		<I18nextProvider i18n={i18n}>
			<QueryClientProvider client={queryClient}>
				<AuthProvider>
					{/* Inside AuthProvider: binds the viewer's brand (ADR-0045 Amendment TO-482). */}
					<AppBrandRoot>
						<RealtimeProvider>
							{/* TO-644: the app's single toast region, for every route (incl. outside Layout). */}
							<ToastProvider>
								<RouterProvider router={router} />
							</ToastProvider>
						</RealtimeProvider>
					</AppBrandRoot>
				</AuthProvider>
			</QueryClientProvider>
		</I18nextProvider>
	)
}

export default App
